import React, { useState, useEffect } from "react";
import { Button } from "../button/Button";
import { Link, NavLink } from "react-router-dom";
import { FaPhone } from "react-icons/fa";
import { FaTimes, FaBars } from "react-icons/fa";

import "./Navbar.css";
import logo from "../../images/logo.svg";

function Navbar({ onClick }) {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img src={logo} className="logo" alt="" />
          </Link>

          <div className="menu-icon" onClick={handleClick}>
            {click ? (
              <FaTimes className="fa-icon" />
            ) : (
              <FaBars className="fa-icon" />
            )}
          </div>

          <ul className={click ? "nav-menu active-menu" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "nav-links active" : "nav-links"
                }
                onClick={closeMobileMenu}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/services"
                className={({ isActive }) =>
                  isActive ? "nav-links active" : "nav-links"
                }
                onClick={closeMobileMenu}
              >
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/products"
                className={({ isActive }) =>
                  isActive ? "nav-links active" : "nav-links"
                }
                onClick={closeMobileMenu}
              >
                Products
              </NavLink>
            </li>

            <li>
              <Link
                to="/#contact"
                className="nav-links-mobile"
                onClick={() => {
                  onClick();
                  closeMobileMenu();
                }}
              >
                Contact Us
              </Link>
            </li>
          </ul>

          {button && (
            <Button
              buttonSize="btn--large"
              type="button"
              onClick={onClick}
              buttonStyle="btn--outline"
            >
              <Link to="/#contact">
                Contact Us <FaPhone className="fa-icon" />
              </Link>
            </Button>
          )}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
